/**
 * custom-product-config.js
 * ─────────────────────────────────────────────────────────────────────────────
 * SINGLE SOURCE OF TRUTH for the product configurator.
 *
 * ARCHITECTURE NOTE — each of the four blocks below is fully independent:
 *   hoodie.printed / hoodie.embroidery / tshirt.printed / tshirt.embroidery
 *
 * They do NOT share colors, sizes, prices, images, or availability.
 * Adding or removing a color/size in one block has zero effect on the others.
 *
 * HOW TO USE:
 *  1. After creating Shopify variants, paste each variant's numeric ID into
 *     the matching slot (search for "REPLACE_WITH_VARIANT_ID").
 *
 *  2. Replace placeholder image URLs with your real Shopify CDN URLs.
 *     Keep images in the order you want them displayed: [front, back, detail…]
 *
 *  3. Update prices in cents to match Shopify exactly.
 *     These values drive the optimistic UI price update.
 *
 *  4. To add a color: add its name to `colors[]`, add a hex to CPC_COLOR_SWATCHES,
 *     add entries to `images`, `variants`, `prices`, and `availability`.
 *
 *  5. To add a size: add it to `sizes[]` and add the corresponding entries
 *     to `variants`, `prices`, and `availability` for every color in that block.
 *
 *  6. To add a garment type: add a top-level key to PRODUCT_CONFIG and add a
 *     matching toggle button (data-group="garment" data-value="jacket") in the
 *     Liquid section. No JS changes required.
 * ─────────────────────────────────────────────────────────────────────────────
 */

// ─── Color swatch hex map ─────────────────────────────────────────────────────
// Every color used across ALL configurations must have an entry here.
// The hex is purely cosmetic — it drives the colored circle swatch in the UI.

window.CPC_COLOR_SWATCHES = {

  // ── Hoodie palette ──────────────────────────────────────────────────────────
  'Pigment Alpine Green': '#4a6741',
  'Pigment Black':        '#1a1a1a',
  'Pigment Light Blue':   '#a8c5d8',
  'Pigment Maroon':       '#6b2737',
  'Pigment Slate Blue':   '#6b7fa3',
  'Pigment Sandstone':    '#c4a882',
  'Pigment Mint':         '#a8d4c0',
  'Pigment Dusty Pink':   '#d4a0a8',
  'Pigment Pink':         '#e8a0b0',

  // ── T-Shirt palette ─────────────────────────────────────────────────────────
  'Faded Grey':           '#b0aaa4',
  'Faded Black':          '#3a3a3a',
  'Faded Brown':          '#8c6e52',
  'Faded Khaki':          '#b8a882',
  'Faded Bone':           '#d9cfc0',
  'Faded Eucalyptus':     '#7a9e8e',
  'Faded Indigo':         '#5c6b8a',

};

// ─── Main configuration object ────────────────────────────────────────────────
window.PRODUCT_CONFIG = {

  // ════════════════════════════════════════════════════════════════════════════
  // HOODIE
  // ════════════════════════════════════════════════════════════════════════════
  hoodie: {

    // ── Printed Hoodie ─────────────────────────────────────────────────────
    // 8 colors · 5 sizes (S–2XL, NO 3XL)
    printed: {
      title: 'Printed Hoodie',

      colors: [
        'Pigment Alpine Green',
        'Pigment Black',
        'Pigment Light Blue',
        'Pigment Maroon',
        'Pigment Slate Blue',
        'Pigment Sandstone',
        'Pigment Mint',
        'Pigment Dusty Pink',
      ],

      // Printed Hoodie intentionally omits 3XL
      sizes: ['S', 'M', 'L', 'XL', '2XL'],

      images: {
        'Pigment Alpine Green': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_2_8.png?v=1779221245',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_2_8.png?v=1779221245',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_12.png?v=1779221244',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_9.png?v=1779221243',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_9.png?v=1779221241',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_18_0fd70415-270e-4e67-946e-0c080ea52063.png?v=1779221240',
],
        'Pigment Black': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_2_11.png?v=1779221425',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_15.png?v=1779221425',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_12.png?v=1779221425',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_2_11.png?v=1779221425',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_12.png?v=1779221424',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_21.png?v=1779221424',
],
        'Pigment Light Blue': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_10.png?v=1779221835',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_2_6.png?v=1779221837',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_2_6.png?v=1779221835',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_7.png?v=1779221838',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_16_726c3476-93c5-415a-b7a0-1928c0adc16b.png?v=1779221832',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_7.png?v=1779221832',
],
        'Pigment Maroon': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_11.png?v=1779221962',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_2_10.png?v=1779221963',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_14.png?v=1779221962',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_2_10.png?v=1779221965',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_20.png?v=1779221961',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_11.png?v=1779221961',
],
        'Pigment Slate Blue': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_2_5_8a281ec5-e86c-4927-aed2-07944990637a.png?v=1779222452',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_9.png?v=1779222452',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_2_5_c6e25a14-558b-4b97-a88f-51b833373405.png?v=1779222452',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_6_baea4e75-fb84-40c9-a54f-0036d3d33168.png?v=1779222451',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_6_77c037e4-ee52-4911-ab5b-c016fd5a67c0.png?v=1779222453',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_15.png?v=1779222450',
],
        'Pigment Sandstone': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_2_9.png?v=1779222331',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_2_9.png?v=1779222330',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_13.png?v=1779222330',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_10.png?v=1779222330',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_19.png?v=1779222328',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_10.png?v=1779222328',
],
        'Pigment Mint': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_2_7.png?v=1779222182',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_11.png?v=1779222181',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_2_7.png?v=1779222181',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_8.png?v=1779222181',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_17_462716a7-1dfa-44c9-9e18-fff47837b5ad.png?v=1779222179',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_8.png?v=1779222179',
],
        'Pigment Dusty Pink': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_2_1_fd865e45-22dd-4be3-bed7-87d3a3aeb6cf.png?v=1779221596',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_3_394c3540-1a17-4258-abc4-a24e6b25c18c.png?v=1779221596',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_2_1_ef8cc8ca-c18b-47c4-bdf3-8de0350b7991.png?v=1779221596',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_2_f8d83d80-4d51-4219-b24a-0a362c8ad90b.png?v=1779221595',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_2_82022390-c909-47a6-b2f3-f3d6358757fb.png?v=1779221594',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_13_dbcb26ff-9d3b-48c0-85c2-7978a71d1fe6.png?v=1779221594',
],
      },

      // !! Replace every REPLACE_WITH_VARIANT_ID with your real Shopify variant IDs !!
      variants: {
        'Pigment Alpine Green': { S: 45399225237538, M: 45399225270306, L: 45399225303074, XL: 45399225335842, '2XL': 45399225368610 },
        'Pigment Black':        { S: 45398539829282, M: 45398539862050, L: 45398539894818, XL: 45398539927586, '2XL': 45398539960354 },
        'Pigment Light Blue':   { S: 45398540058658, M: 45398540091426, L: 45398540124194, XL: 45398540156962, '2XL': 45398540189730 },
        'Pigment Maroon':       { S: 45398540288034, M: 45398540320802, L: 45398540353570, XL: 45398540386338, '2XL': 45398540419106 },
        'Pigment Slate Blue':   { S: 45398540517410, M: 45398540550178, L: 45398540582946, XL: 45398540615714, '2XL': 45398540648482 },
        'Pigment Sandstone':    { S: 45398540746786, M: 45398540779554, L: 45398540812322, XL: 45398540845090, '2XL': 45398540877858 },
        'Pigment Mint':         { S: 45399225466914, M: 45399225499682, L: 45399225532450, XL: 45399225565218, '2XL': 45399225597986 },
        'Pigment Dusty Pink':   { S: 45398588358690, M: 45398588391458, L: 45398588424226, XL: 45398588456994, '2XL': 45398588489762 },
      },
 
      prices: {
        'Pigment Alpine Green': { S: 5499, M: 5499, L: 5499, XL: 5999, '2XL': 5999 },
        'Pigment Black':        { S: 5499, M: 5499, L: 5499, XL: 5999, '2XL': 5999 },
        'Pigment Light Blue':   { S: 5499, M: 5499, L: 5499, XL: 5999, '2XL': 5999 },
        'Pigment Maroon':       { S: 5499, M: 5499, L: 5499, XL: 5999, '2XL': 5999 },
        'Pigment Slate Blue':   { S: 5499, M: 5499, L: 5499, XL: 5999, '2XL': 5999 },
        'Pigment Sandstone':    { S: 5499, M: 5499, L: 5499, XL: 5999, '2XL': 5999 },
        'Pigment Mint':         { S: 5499, M: 5499, L: 5499, XL: 5999, '2XL': 5999 },
        'Pigment Dusty Pink':   { S: 5499, M: 5499, L: 5499, XL: 5999, '2XL': 5999 },
      },

      // false = sold out → size button disabled with strikethrough
      availability: {
        'Pigment Alpine Green': { S: true,  M: true,  L: true,  XL: true,  '2XL': true  },
        'Pigment Black':        { S: true,  M: true,  L: true,  XL: true,  '2XL': true  },
        'Pigment Light Blue':   { S: true,  M: true,  L: true,  XL: true,  '2XL': true  },
        'Pigment Maroon':       { S: true,  M: true,  L: true,  XL: true,  '2XL': true  },
        'Pigment Slate Blue':   { S: true,  M: true,  L: true,  XL: true,  '2XL': true  },
        'Pigment Sandstone':    { S: true,  M: true,  L: true,  XL: true,  '2XL': true  },
        'Pigment Mint':         { S: true,  M: true,  L: true,  XL: true,  '2XL': true  },
        'Pigment Dusty Pink':   { S: true,  M: true,  L: true,  XL: true,  '2XL': true  },
      },
    },

    // ── Embroidered Hoodie ──────────────────────────────────────────────────
    // 6 colors · 6 sizes (S–3XL, INCLUDES 3XL)
    embroidery: {
      title: 'Embroidered Hoodie',

      colors: [
        'Pigment Alpine Green',
        'Pigment Light Blue',
        'Pigment Slate Blue',
        'Pigment Black',
        'Pigment Pink',
        'Pigment Maroon',
      ],

      // Embroidered Hoodie includes 3XL
      sizes: ['S', 'M', 'L', 'XL', '2XL', '3XL'],

      images: {
        'Pigment Alpine Green': [
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person2Front_5.png?v=1779218794',
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person1Front_4.png?v=1779218794',
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front2_3.png?v=1779218794',
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_16.png?v=1779218794',
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back2_3.png?v=1779218794',
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_4.png?v=1779218794',
        ],
        'Pigment Light Blue': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_2_4.png?v=1779219799',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_2_4.png?v=1779219799',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_2_4.png?v=1779219798',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_5.png?v=1779219798',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_5.png?v=1779219798',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_16_01ac0d29-9f1f-452b-bdf2-e1239074e999.png?v=1779219797',
],
        'Pigment Slate Blue': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_2_3.png?v=1779220639',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_5.png?v=1779220638',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_2_3.png?v=1779220638',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_4_a0a39023-8a1d-4935-a053-8d21b85a128f.png?v=1779220638',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_17.png?v=1779220636',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_4.png?v=1779220636',
],
        'Pigment Black': [
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_2_1.png?v=1779219256',
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_2_1.png?v=1779219256',
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_2.png?v=1779219256',
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_3.png?v=1779219256',
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_13.png?v=1779219255',
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_2.png?v=1779219253',
        ],
        'Pigment Pink': [
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_6_dbd34155-3dce-4e68-ad35-aa0c2578f128.png?v=1779220449',
'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_2_5.png?v=1779220451',
'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_2_5.png?v=1779220449',
'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_6.png?v=1779220448',
'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_18.png?v=1779220448',
'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_6.png?v=1779220448',        
],
        'Pigment Maroon': [
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_2_2.png?v=1779219965',
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_2_2.png?v=1779219965',
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_4.png?v=1779219965', 
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_3.png?v=1779219964',
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_14.png?v=1779219964',
          'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_3.png?v=1779219964',       ],
      },

      variants: {
        'Pigment Alpine Green': { S: 45399225696290, M: 45399225729058, L: 45399225761826, XL: 45399225794594, '2XL': 45399225827362, '3XL': 45399225860130 },
        'Pigment Light Blue':   { S: 45398541205538, M: 45398541238306, L: 45398541271074, XL: 45398541303842, '2XL': 45398541336610, '3XL': 45398541369378 },
        'Pigment Slate Blue':   { S: 45398541664290, M: 45398541697058, L: 45398541729826, XL: 45398541762594, '2XL': 45398541795362, '3XL': 45398541828130 },
        'Pigment Black':        { S: 45398540976162, M: 45398541008930, L: 45398541041698, XL: 45398541074466, '2XL': 45398541107234, '3XL': 45398541140002 },
        'Pigment Pink':         { S: 45398590423074, M: 45398590455842, L: 45398590488610, XL: 45398590521378, '2XL': 45398590554146, '3XL': 45398590586914 },
        'Pigment Maroon':       { S: 45398541434914, M: 45398541467682, L: 45398541500450, XL: 45398541533218, '2XL': 45398541565986, '3XL': 45398541598754 },
      },

      prices: {
        'Pigment Alpine Green': { S: 6999, M: 6999, L: 6999, XL: 7499, '2XL': 7499, '3XL': 7999 },
        'Pigment Light Blue':   { S: 6999, M: 6999, L: 6999, XL: 7499, '2XL': 7499, '3XL': 7999 },
        'Pigment Slate Blue':   { S: 6999, M: 6999, L: 6999, XL: 7499, '2XL': 7499, '3XL': 7999 },
        'Pigment Black':        { S: 6999, M: 6999, L: 6999, XL: 7499, '2XL': 7499, '3XL': 7999 },
        'Pigment Pink':         { S: 6999, M: 6999, L: 6999, XL: 7499, '2XL': 7499, '3XL': 7999 },
        'Pigment Maroon':       { S: 6999, M: 6999, L: 6999, XL: 7499, '2XL': 7499, '3XL': 7999 },
      },

      availability: {
        'Pigment Alpine Green': { S: true, M: true, L: true, XL: true,  '2XL': true,  '3XL': true  },
        'Pigment Light Blue':   { S: true, M: true, L: true, XL: true,  '2XL': true,  '3XL': true  },
        'Pigment Slate Blue':   { S: true, M: true, L: true, XL: true,  '2XL': true,  '3XL': true  },
        'Pigment Black':        { S: true, M: true, L: true, XL: true,  '2XL': true,  '3XL': true  },
        'Pigment Pink':         { S: true, M: true, L: true, XL: true,  '2XL': true,  '3XL': true  },
        'Pigment Maroon':       { S: true, M: true, L: true, XL: true,  '2XL': true, '3XL': true   },
      },
    },
  },

  // ════════════════════════════════════════════════════════════════════════════
  // T-SHIRT
  // ════════════════════════════════════════════════════════════════════════════
  tshirt: {

    // ── Printed T-Shirt ────────────────────────────────────────────────────
    // 7 colors · 6 sizes (S–3XL)
    printed: {
      title: 'Printed T-Shirt',

      colors: [
        'Faded Grey',
        'Faded Black',
        'Faded Brown',
        'Faded Khaki',
        'Faded Bone',
        'Faded Eucalyptus',
        'Faded Indigo',
      ],

      sizes: ['S', 'M', 'L', 'XL', '2XL', '3XL'],

      images: {
        'Faded Grey': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_Faded_Grey.jpg?v=1779226342',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_2_Faded_Grey.jpg?v=1779226342',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Back_Faded_Grey.jpg?v=1779226342',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Back_Faded_Grey.jpg?v=1779226342',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_Faded_Grey.jpg?v=1779226342',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_Faded_Grey.jpg?v=1779226342',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_Faded_Grey.jpg?v=1779226342',
],
        'Faded Black': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_Faded_Black.jpg?v=1779225203',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_Faded_Black.jpg?v=1779225202',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Back_Faded_Black.jpg?v=1779225202',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_2_Faded_Black.jpg?v=1779225202',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_Faded_Black.jpg?v=1779225202',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Back_Faded_Black.jpg?v=1779225202',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_Faded_Black.jpg?v=1779225202',
],
        'Faded Brown': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_2_Faded_Brown.jpg?v=1779226004',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_Faded_Brown.jpg?v=1779226003',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_Faded_Brown.jpg?v=1779226003',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Back_Faded_Brown.jpg?v=1779226003',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_Faded_Brown.jpg?v=1779226003',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Back_Faded_Brown.jpg?v=1779226003',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_Faded_Brown.jpg?v=1779226003',
],
        'Faded Khaki': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Back_Faded_Khaki.jpg?v=1779226829',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_2_Faded_Khaki.jpg?v=1779226829',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_Faded_Khaki.jpg?v=1779226829',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_Faded_Khaki.jpg?v=1779226829',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Back_Faded_Khaki.jpg?v=1779226829',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_Faded_Khaki.jpg?v=1779226829',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_Faded_Khaki.jpg?v=1779226829',
],
        'Faded Bone': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_Faded_Bone.jpg?v=1779225824',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_2_Faded_Bone.jpg?v=1779225824',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Back_Faded_Bone.jpg?v=1779225824',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_Faded_Bone.jpg?v=1779225824',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_Faded_Bone.jpg?v=1779225824',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Back_Faded_Bone.jpg?v=1779225824',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_Faded_Bone.jpg?v=1779225824',
],
        'Faded Eucalyptus': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Back_Faded_Eucalyptus.jpg?v=1779226141',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_Faded_Eucalyptus.jpg?v=1779226141',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_Faded_Eucalyptus.jpg?v=1779226141',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_Faded_Eucalyptus.jpg?v=1779226141',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Back_Faded_Eucalyptus.jpg?v=1779226141',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_2_Faded_Eucalyptus.jpg?v=1779226141',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_Faded_Eucalyptus.jpg?v=1779226141',
],
        'Faded Indigo': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_Faded_Indigo.jpg?v=1779226631',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_Faded_Indigo.jpg?v=1779226631',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_Faded_Indigo.jpg?v=1779226631',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Back_Faded_Indigo.jpg?v=1779226631',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Back_Faded_Indigo.jpg?v=1779226631',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_Faded_Indigo.jpg?v=1779226631',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_2_Faded_Indigo.jpg?v=1779226631',
],
      },

      variants: {
        'Faded Grey':       { S: 45398592421922, M: 45398592454690, L: 45398592487458, XL: 45398592520226, '2XL': 45398592552994, '3XL': 45398592585762 },
        'Faded Black':      { S: 45398592618530, M: 45398592651298, L: 45398592684066, XL: 45398592716834, '2XL': 45398592749602, '3XL': 45398592782370 },
        'Faded Brown':      { S: 45398592815138, M: 45398592847906, L: 45398592880674, XL: 45398592913442, '2XL': 45398592946210, '3XL': 45398592978978 },
        'Faded Khaki':      { S: 45398593011746, M: 45398593044514, L: 45398593077282, XL: 45398593110050, '2XL': 45398593142818, '3XL': 45398593175586 },
        'Faded Bone':       { S: 45398593208354, M: 45398593241122, L: 45398594093090, XL: 45398594125858, '2XL': 45398594158626, '3XL': 45398594191394 },
        'Faded Eucalyptus': { S: 45398594224162, M: 45398594256930, L: 45398594289698, XL: 45398594322466, '2XL': 45398594355234, '3XL': 45398594388002 },
        'Faded Indigo':     { S: 45397080375330, M: 45397080408098, L: 45397080440866, XL: 45397080473634, '2XL': 45397080506402, '3XL': 45397080539170 },
      },

      prices: {
        'Faded Grey':       { S: 3999, M: 3999, L: 3999, XL: 4499, '2XL': 4499, '3XL': 4999 },
        'Faded Black':      { S: 3999, M: 3999, L: 3999, XL: 4499, '2XL': 4499, '3XL': 4999 },
        'Faded Brown':      { S: 3999, M: 3999, L: 3999, XL: 4499, '2XL': 4499, '3XL': 4999 },
        'Faded Khaki':      { S: 3999, M: 3999, L: 3999, XL: 4499, '2XL': 4499, '3XL': 4999 },
        'Faded Bone':       { S: 3999, M: 3999, L: 3999, XL: 4499, '2XL': 4499, '3XL': 4999 },
        'Faded Eucalyptus': { S: 3999, M: 3999, L: 3999, XL: 4499, '2XL': 4499, '3XL': 4999 },
        'Faded Indigo':     { S: 3999, M: 3999, L: 3999, XL: 4499, '2XL': 4499, '3XL': 4999 },
      },

      availability: {
        'Faded Grey':       { S: true, M: true, L: true, XL: true, '2XL': true,  '3XL': true  },
        'Faded Black':      { S: true, M: true, L: true, XL: true, '2XL': true,  '3XL': true  },
        'Faded Brown':      { S: true, M: true, L: true, XL: true, '2XL': true,  '3XL': true  },
        'Faded Khaki':      { S: true, M: true, L: true, XL: true, '2XL': true,  '3XL': true  },
        'Faded Bone':       { S: true, M: true, L: true, XL: true, '2XL': true,  '3XL': true  },
        'Faded Eucalyptus': { S: true, M: true, L: true, XL: true, '2XL': true,  '3XL': true  },
        'Faded Indigo':     { S: true, M: true, L: true, XL: true, '2XL': true,  '3XL': true  },
      },
    },

    // ── Embroidered T-Shirt ────────────────────────────────────────────────
    // 3 colors · 6 sizes (S–3XL) — smaller independent range
    embroidery: {
      title: 'Embroidered T-Shirt',

      colors: [
        'Faded Khaki',
        'Faded Eucalyptus',
        'Faded Black',
      ],

      sizes: ['S', 'M', 'L', 'XL', '2XL', '3XL'],

      images: {
        'Faded Khaki': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_8_7fb4714d-6531-44df-a836-6cb701ed85ce.png?v=1779225021',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_2_2.png?v=1779225020',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_20_76e74073-69b8-46e2-afb2-9e78ff33c620.png?v=1779225023',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_9_02a270d4-3f28-4fe2-a66d-7157e326f619.png?v=1779225020',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Back_1.png?v=1779225019',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Back_1.png?v=1779225018',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_8_a0309e52-bec6-477e-a002-21bb5e6dfc6d.png?v=1779225018',
],
        'Faded Eucalyptus': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_9_eec6d7cc-5e31-4959-9f4f-34426dd128d9.png?v=1779222932',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_21_29fbdcc4-4f51-4bfa-b0ed-13c6b12a3865.png?v=1779222932',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_2_3.png?v=1779222932',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_10_e1870f16-cb76-490f-9173-697cd47d4182.png?v=1779222932',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Back_2.png?v=1779222931',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Back_2.png?v=1779222931',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_9_d144bf29-fcfe-44f6-b58f-fc87e1f4aa90.png?v=1779222931',
],
        'Faded Black': [
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Front_8.png?v=1779222672',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Front_19_fdf229a9-4448-434b-82a7-d9620b0d2c71.png?v=1779222674',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Back_7_51a33df4-cb99-4f88-b163-3a23cf63e970.png?v=1779222672',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_2_1.png?v=1779222672',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Back.png?v=1779222652',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_2_Back.png?v=1779222652',
  'https://cdn.shopify.com/s/files/1/0703/1318/1218/files/Person_1_Front_7_9dadde15-bd7c-4f83-8ef9-8a752a880814.png?v=1779222651',
]
      },

      variants: {
        'Faded Khaki':      { S: 45398595403810, M: 45398595436578, L: 45398595469346, XL: 45398595502114, '2XL': 45398595534882, '3XL': 45398595567650 },
        'Faded Eucalyptus': { S: 45398595797026, M: 45398595829794, L: 45398595862562, XL: 45398595895330, '2XL': 45398595928098, '3XL': 45398595960866 },
        'Faded Black':      { S: 45398595010594, M: 45398595043362, L: 45398595076130, XL: 45398595108898, '2XL': 45398595141666, '3XL': 45398595174434 },
      },

      prices: {
        'Faded Khaki':      { S: 5499, M: 5499, L: 5499, XL: 5999, '2XL': 5999, '3XL': 6499 },
        'Faded Eucalyptus': { S: 5499, M: 5499, L: 5499, XL: 5999, '2XL': 5999, '3XL': 6499 },
        'Faded Black':      { S: 5499, M: 5499, L: 5499, XL: 5999, '2XL': 5999, '3XL': 6499 },
      },

      availability: {
        'Faded Khaki':      { S: true, M: true, L: true, XL: true, '2XL': true, '3XL': true  },
        'Faded Eucalyptus': { S: true, M: true, L: true, XL: true, '2XL': true, '3XL': true  },
        'Faded Black':      { S: true, M: true, L: true, XL: true, '2XL': true, '3XL': true },
      },
    },
  },
};

/**
 * ─── Flat variant reverse-lookup map ─────────────────────────────────────────
 * Auto-built at runtime from PRODUCT_CONFIG above.
 * Provides O(1) deep-link init: URL ?variant=ID → { garment, decoration, color, size }
 *
 * Only entries where the variant ID has been set (not placeholder) are included.
 * This means during development (all placeholders) the lookup is empty and the
 * configurator falls back to DEFAULT_STATE — this is safe and expected.
 */
window.CPC_VARIANT_LOOKUP = (function buildLookup() {
  const lookup = {};
  const cfg    = window.PRODUCT_CONFIG;

  for (const garment in cfg) {
    for (const decoration in cfg[garment]) {
      const block = cfg[garment][decoration];
      for (const color in block.variants) {
        for (const size in block.variants[color]) {
          const vid = block.variants[color][size];
          if (vid && vid !== 'REPLACE_WITH_VARIANT_ID') {
            // Store as string — URL params are always strings
            lookup[String(vid)] = { garment, decoration, color, size };
          }
        }
      }
    }
  }

  return lookup;
}());